import { FC, useCallback, useState } from "react"
import { facilityDeleteApi } from "src/domain/api/facility/facilityDeleteApi"
import { Facility } from "src/domain/entities/facility"
import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	facility: Facility
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const FacilityDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	facility,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleFacilityDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await facilityDeleteApi({ id: facility.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [facility, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Facility: ${facility.name.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleFacilityDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
